export interface UserProfileUpdateRequestModel {
  name: string;
}
